export const API_BASE_URL = "https://api.pl.iosx.in/api/v1/";
export const SOCKET_URL = "https://api.pl.iosx.in";
// export const API_BASE_URL = "http://192.168.1.104:3666/api/v1";
// export const SOCKET_URL = "http://192.168.1.104:3666";
